import { getBearerToken } from '@entities/authentication'
import { rpc } from '@server/infrastructure/rpc'

export const getSelfWithdrawalEligibility = async () => {
  const token = await getBearerToken()
  const response = await rpc.api.v1.users.withdrawal.$get({}, { headers: { Authorization: `Bearer ${token}` } })

  if (!response.ok) {
    throw new Error(`Failed to get withdrawal eligibility: ${response.status}`)
  }

  return response.json()
}

export const withdrawCurrentUser = async () => {
  const token = await getBearerToken()
  const response = await rpc.api.v1.users.withdrawal.$delete({}, { headers: { Authorization: `Bearer ${token}` } })

  if (!response.ok) {
    throw new Error(`Failed to withdraw current user: ${response.status}`)
  }

  return response.json()
}
